<template>
  <div class="row">
    <SwappingSquaresSpinner v-if="this.$store.getters.isLoading"
      :animation-duration="1000"
      :size="90"
      :color="this.$store.getters.config.palette.primary"
      style="margin: auto; position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);"
    />
    <div v-if="!this.$store.getters.isLoading" class="flex xs12">
      <va-card :title="location.name">
        <template slot="actions">
          <va-button v-if="location.latitude && location.longtitude" icon="fa fa-map-marker" @click.prevent="openMaps" />
          <va-button icon="fa fa-edit" @click.prevent="editModal" />
          <va-button icon="fa fa-print" @click.prevent="toPrinters" />
        </template>
        <div class="va-card__body" v-if="mainCardBody">
          <va-notification v-if="spots.length < 1" color="warning">
            <va-badge color="warning">
              {{ $t('events.crucial') }}
            </va-badge>
            {{ $t('events.createSlots') }}
            <va-badge style="margin-left: 20px;" color="info">
              {{ $t('events.clickHere') }}
            </va-badge>
          </va-notification>
          <va-notification v-if="users.length < 1" color="info" closeable>
            <va-badge color="info">
              {{ $t('badges.info') }}
            </va-badge>
            {{ $t('events.addUsers') }}
          </va-notification>
        </div>
      </va-card>
    </div>

    <div v-if="!this.$store.getters.isLoading" class="flex xs12 sm6 lg6 xl6">
      <ClientsLocationTable :lclients="this.clients" :location-id="locationId" />
    </div>
    <div v-if="!this.$store.getters.isLoading" class="flex xs12 sm6 lg6 xl6">
      <UsersLocationTable :lusers="this.users" :location-id="locationId" />
    </div>
    <div v-if="!this.$store.getters.isLoading" class="flex xs12 sm6 lg6 xl6">
      <SubscriptionLocationTable :location-id="locationId" />
    </div>
    <div v-if="!this.$store.getters.isLoading" class="flex xs12 sm6 lg6 xl6">
      <SpotLocationTable :lspots="this.spots" :location-id="locationId" />
    </div>
    <div v-if="!this.$store.getters.isLoading" class="flex xs12">
      <va-card stripe="success" :title="$t('events.content')">
        <template v-for="(content, index) in this.contentList">
          <ContentCard :content="content" :key="index" @content-deleted="deleteContentItem" @content-duplicated="addContent" />
        </template>
      </va-card>
    </div>
    <va-modal
      v-model="openEditModal"
      :title="$t('events.modal.title')"
      :hideDefaultActions="true"
      :noOutsideDismiss="true"
      :noEscDismiss="true"
    >
      <form>
        <div class="row">
          <va-input
            v-model="editLocation.name"
            type="text"
            :label="$t('events.modal.eventName')"
            :error="!!nameErrors.length"
            :error-messages="nameErrors"
            class="flex xs12"
          />

          <div class="flex xs6">
            {{ $t('events.modal.openFrom') }}: <vue-timepicker
              v-model="editLocation.openHour"
              :minute-interval="10"
            />
          </div>

          <div class="flex xs6">
            {{ $t('events.modal.closeOn') }}: <vue-timepicker
              v-model="editLocation.closeHour"
              :minute-interval="10"
            />
          </div>
          <span>{{ $t('events.modal.leaveHours') }}</span>
          <fieldset style="margin-top: 20px;">
            <va-checkbox
              :label="$t('events.modal.closeLocation')"
              v-model="editLocation.isClosed"
            />
          </fieldset>
        </div>
        <div class="d-flex justify--center mt-3">
          <va-button color="gray" @click.prevent="closeModal()" class="my-0 ">{{ $t('events.modal.close') }}</va-button>
          <va-button type="submit" @click.prevent="onEditSubmit()" class="my-0">{{ $t('events.modal.update') }}</va-button>
        </div>
      </form>
    </va-modal>
  </div>
</template>

<script>
import { SwappingSquaresSpinner } from 'epic-spinners'
import UsersLocationTable from '../events/UsersLocationTable'
import ClientsLocationTable from '../events/ClientsLocationTable'
import SpotLocationTable from '../events/SpotLocationTable'
import SubscriptionLocationTable from './SubscriptionLocationTable'
import VueTimepicker from 'vue2-timepicker/src/vue-timepicker.vue'
import errorHandlerMixin from '@/mixin/errorHandlerMixin'
import ContentCard from '@/components/content/ContentCard.vue'
export default {
  components: { SwappingSquaresSpinner, UsersLocationTable, ClientsLocationTable, SpotLocationTable, SubscriptionLocationTable, VueTimepicker, ContentCard },
  name: 'Location',
  mixins: [errorHandlerMixin],
  data () {
    return {
      locationId: 0,
      location: {},
      clients: [],
      users: [],
      spots: [],
      editLocation: {
        name: '',
        openHour: '',
        closeHour: '',
        isClosed: false,
      },
      openEditModal: false,
      nameErrors: [],
      openCloseHourErrors: [],
      contentList: [],
    }
  },
  methods: {
    async toPrinters () {
      await this.$router.push({
        name: 'printers',
        params: { locationId: this.locationId },
      })
    },
    editModal () {
      this.openEditModal = true
    },
    closeModal () {
      this.openEditModal = false
    },
    onEditSubmit () {
      this.nameErrors = this.editLocation.name ? [] : [this.$t('events.requiredName')]
      if (this.nameErrors.length) {
        return
      }

      if (this.editLocation.openHour || this.editLocation.closeHour) {
        if (!this.editLocation.openHour || !this.editLocation.closeHour) {
          this.openCloseHourErrors = [this.$t('events.requiredBothTimes')]
        }
      }

      if (this.editLocation.openHour && this.editLocation.closeHour) {
      }
      this.$store.dispatch('updateLocation', {
        locationId: this.locationId,
        name: this.editLocation.name,
        openHour: this.editLocation.openHour.HH + ':' + this.editLocation.openHour.mm,
        closeHour: this.editLocation.closeHour.HH + ':' + this.editLocation.closeHour.mm,
        isClosed: this.editLocation.isClosed,
      }).then().catch(err => this.errorHandler(err.response))
    },
    async initLocation () {
      this.location = this.$store.getters.location
      this.editLocation.name = this.location.name
      this.editLocation.openHour = this.location.openHour
      this.editLocation.closeHour = this.location.closeHour
      this.editLocation.isClosed = this.location.isClosed
      this.$store.commit('setLoading', false)
    },
    async initClients (clients) {
      this.clients.splice(0, this.clients.length, ...clients)
    },
    async initUsers (users) {
      this.users.splice(0, this.users.length, ...users)
    },
    async initSpots (spots) {
      this.spots.splice(0, this.spots.length, ...spots)
    },
    toDashboard () {
      this.$router.push({
        name: 'dashboard',
      })
    },
    notThisLocation () {
      this.toDashboard()
    },
    openMaps () {
      window.open('https://www.google.com/maps/search/?api=1&query=' + this.location.latitude + ',' + this.location.longtitude, '_blank')
    },
    async initContentList (contentList) {
      this.contentList.splice(0, this.contentList.length, ...contentList)
    },
    deleteContentItem (appContentId) {
      this.contentList = this.contentList.filter(item => item.appContentId !== appContentId)
    },
    addContent (newContent) {
      this.contentList.push(newContent)
    },
  },
  computed: {
    mainCardBody () {
      return this.spots.length < 1 || this.users.length < 1
    },
  },
  mounted () {
    this.locationId = Number.parseInt(this.$route.params.locationId)
    if (!this.locationId) {
      this.toDashboard()
    }
    this.$store.commit('setLoading', true)
    this.$store.dispatch('getLocation', this.$route.params.locationId).catch(this.notThisLocation)
      .then(() => this.$store.dispatch('clientsLocationRequest', this.$route.params.locationId))
      .then((resp) => this.initClients(resp.data.message))
      .then(() => this.$store.dispatch('appUserLocationRequest', this.$route.params.locationId))
      .then((resp) => this.initUsers(resp.data.message))
      .then(() => this.$store.dispatch('getLocationSpots', this.$route.params.locationId))
      .then((resp) => this.initSpots(resp.data.message))
      .then(() => this.initLocation())
      .then(() => this.$store.dispatch('getLocationContentList', this.$route.params.locationId))
      .then((resp) => this.initContentList(resp.data.message))
      .catch((err) => this.errorHandler(err.response))
  },
}
</script>

<style scoped type="scss">
</style>
